"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BestaandeLeerlingForm = void 0;
var react_1 = __importDefault(require("react"));
var Cart_1 = require("./Cart");
var useCart_1 = require("../hooks/useCart");
function LoginForm(_a) {
    var _this = this;
    var onLogin = _a.onLogin;
    var _b = react_1.default.useState(""), userName = _b[0], setUserName = _b[1];
    var _c = react_1.default.useState(""), password = _c[0], setPassword = _c[1];
    var _d = react_1.default.useState(false), loading = _d[0], setLoading = _d[1];
    var _e = react_1.default.useState(""), error = _e[0], setError = _e[1];
    var handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setLoading(true);
                    setError("");
                    return [4 /*yield*/, (0, useCart_1.postFormData)("login/checklogin.php", {
                            myusername: userName,
                            mypassword: password,
                        })];
                case 1:
                    result = _a.sent();
                    if (result.response === "true") {
                        onLogin(result);
                    }
                    else {
                        setError(result.response);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "col col-md-8 col-lg-6 col-xl-4 offset-md-2 offset-lg-3 offset-xl-4" },
        react_1.default.createElement("br", null),
        react_1.default.createElement("input", { name: "myusername", id: "myusername", value: userName, onChange: function (e) { return setUserName(e.target.value); }, type: "text", className: "form-control mb-2", placeholder: "Gebruikersnaam", autoComplete: "username", autoFocus: true }),
        react_1.default.createElement("input", { name: "mypassword", id: "mypassword", value: password, onChange: function (e) { return setPassword(e.target.value); }, type: "password", className: "form-control", autoComplete: "current-password", placeholder: "Wachtwoord" }),
        react_1.default.createElement("br", null),
        react_1.default.createElement("button", { name: "Submit", id: "loginSubmit", className: "btn btn-lg btn-green1 btn-block", 
            // type="submit"
            disabled: !userName || !password, onClick: handleSubmit }, "Inloggen"),
        react_1.default.createElement("div", { id: "loginMessage", className: "mt-3" },
            loading && (react_1.default.createElement("p", { className: "text-center" },
                react_1.default.createElement("img", { width: "20px", src: "https://info3.readytoschool.nl/_general/images/RTS_loader.gif" }))),
            react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: error } }))));
}
function UserData(_a) {
    var _this = this;
    var user = _a.user, leerlingState = _a.leerlingState, onLogout = _a.onLogout, onSubmit = _a.onSubmit;
    var leerling = leerlingState[0], setLeerling = leerlingState[1];
    var count = (0, useCart_1.useCart)().count;
    var logout = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, useCart_1.postFormData)("shop_handler.php", { task: "logout" })];
                case 1:
                    _a.sent();
                    onLogout();
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "card-body" },
            react_1.default.createElement("p", null,
                "Je bent nu ingelogd als ",
                user.loginName,
                react_1.default.createElement("button", { className: "btn btn-outline-secondary float-right", onClick: function () { return logout(); } }, "Uitloggen"))),
        react_1.default.createElement("div", { className: "card-body" },
            react_1.default.createElement("h4", { className: "card-title" }, "Leerling"),
            react_1.default.createElement("div", { className: "form-row" },
                react_1.default.createElement("div", { className: "col" },
                    react_1.default.createElement("div", { className: "form-group input-group" },
                        react_1.default.createElement("select", { className: "form-control", name: "leerlingID", required: true, value: leerling || "", onChange: function (e) { return setLeerling(e.target.value); } }, user.leerlingen.map(function (leerling) {
                            return (react_1.default.createElement("option", { key: leerling.ID, value: leerling.ID }, leerling.naam));
                        }))))),
            react_1.default.createElement("h4", { className: "card-title" }, "Ouder(s) / Verzorger(s)"),
            react_1.default.createElement("div", { className: "form-row" },
                react_1.default.createElement("div", { className: "col" },
                    react_1.default.createElement("p", { className: "mb-0" }, user.ouder.naam),
                    react_1.default.createElement("p", { className: "mb-0" }, user.ouder.email),
                    react_1.default.createElement("p", { className: "mb-0" }, user.ouder.telefoon))),
            react_1.default.createElement("h4", { className: "card-title" }, "Betalen"),
            react_1.default.createElement("div", { className: "form-row" },
                react_1.default.createElement("div", { className: "col" },
                    react_1.default.createElement("p", null, "De examentrainingen worden aan je persoonlijke profiel toegevoegd. Begin mei worden de trainingen meegenomen in de reguliere facturatie."),
                    react_1.default.createElement("p", { className: "text-center" },
                        react_1.default.createElement("button", { type: "submit", name: "task", value: "inschrijvenBestaand", className: "btn btn-green2", onClick: onSubmit, disabled: !leerling || !count },
                            react_1.default.createElement("i", { className: "far fa-calendar-check fa-3x" }),
                            react_1.default.createElement("br", null),
                            "Inschrijving definitief maken")))))));
}
function BestaandeLeerlingForm() {
    var _this = this;
    var _a;
    var ref = react_1.default.useRef(null);
    var markState = react_1.default.useState([]);
    var leerlingState = react_1.default.useState(null);
    var _b = react_1.default.useState(null), user = _b[0], setUser = _b[1];
    var cart = (0, useCart_1.useCart)().cart;
    var trainingenCount = (_a = cart === null || cart === void 0 ? void 0 : cart.trainingen.length) !== null && _a !== void 0 ? _a : 0;
    var getUser = function () { return __awaiter(_this, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, useCart_1.postFormData)("shop_handler.php", {
                        task: "checkLogin",
                    })];
                case 1:
                    result = _b.sent();
                    if (result.login) {
                        setUser(result);
                        leerlingState[1](((_a = result.leerlingen[0]) === null || _a === void 0 ? void 0 : _a.ID.toString()) || null);
                    }
                    else {
                        setUser(null);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.default.useEffect(function () {
        getUser();
    }, []);
    var handleLogin = function () {
        getUser();
    };
    var handleLogout = function () {
        setUser(null);
    };
    var handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var valid, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    valid = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.reportValidity();
                    if (!valid) return [3 /*break*/, 2];
                    console.log("submit", leerlingState[0]);
                    return [4 /*yield*/, (0, useCart_1.postFormData)("shop_handler.php", {
                            task: "inschrijvenBestaand",
                            leerlingID: leerlingState[0],
                            marks: markState[0],
                        })];
                case 1:
                    result = _b.sent();
                    try {
                        // redirect if result is a url
                        new URL(result);
                        window.location.href = result;
                    }
                    catch (e) {
                        console.log("result is not a url", result);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    console.log("form invalid");
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "card-body" },
        react_1.default.createElement("form", { ref: ref },
            react_1.default.createElement("div", { className: "cart" },
                react_1.default.createElement("h4", { className: "card-title" }, "Overzicht"),
                !!trainingenCount && (react_1.default.createElement("p", null, "Vul hieronder je gemiddelde SE cijfer in.")),
                react_1.default.createElement(Cart_1.Cart, { state: markState })),
            react_1.default.createElement("div", { className: "row", id: "loginContainer" },
                !user && react_1.default.createElement(LoginForm, { onLogin: handleLogin }),
                !!user && (react_1.default.createElement(UserData, { user: user, leerlingState: leerlingState, onLogout: handleLogout, onSubmit: handleSubmit }))))));
}
exports.BestaandeLeerlingForm = BestaandeLeerlingForm;
